import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { TaskLabelCollection } from '../index'

export const setupTaskLabelReplication = (
  collection: TaskLabelCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'tasklabels',
    displayName: 'TaskLabel',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      taskId: doc.workItemId || doc.taskId, // Backend sends workItemId
      labelId: doc.labelId,
      labelGroupId: doc.labelGroupId,
      isDeleted: doc.isDeleted || false,
      labelName: doc.labelName,
      labelColor: doc.labelColor,
      labelGroupName: doc.labelGroupName,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      workItemId: state.taskId, // Frontend uses taskId, backend expects workItemId
      labelId: state.labelId,
      labelGroupId: state.labelGroupId,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
